import React from 'react'
import { CurrentDepositWrapper, DepositTitle } from '../styles';
import { Table } from 'antd';
import { useCurrentDeposit } from 'CRM/hooks/Dashboard/GetCurrentDeposit';
import {useIsMobile} from "../../../components/IsMobile";
import {MobileCalVW} from "../../../components/CalVW";

export const CurrentDeposit = () => {
  const { currentDepositData } = useCurrentDeposit();
  const IsMobile = useIsMobile();

  const mobileColumns = [
    {
      dataIndex: '',
      title: '번호',
      render: (value, data, index) => {
        return (
          <div className='num' >{index + 1}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '입금 내역 리스트',
      render: (value, data) => {
        return (
          <>
            <div className='name' style={{display: 'flex', alignItems: 'center'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>이름: </p> {data?.name || '-'}</div>
            <div className='name' style={{display: 'flex', alignItems: 'center'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>이메일: </p>{data?.email || '-'}</div>
            <div className='name' style={{display: 'flex', alignItems: 'center'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>입금일자: </p> {data?.createdAt || '-'}</div>
            <div className='name' style={{display: 'flex', alignItems: 'center'}}><p style={{marginRight: 5, fontWeight: 'bold'}}>담당자: </p> {data?.responsiblity || '-'}</div>
          </>
        )
      }
    },
  ]

  const columns = [
    {
      dataIndex: '',
      title: '번호',
      render: (value, data, index) => {
        return (
          <div className='num'>{index + 1}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '이름',
      render: (value, data) => {
        return (
          <div className='name'>{data?.name}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '이메일',
      render: (value, data) => {
        return (
          <div className='email'>{data?.email}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '입금일자',
      render: (value, data) => {
        return (
          <div className='deposit'>{data?.createdAt}</div>
        )
      }
    },
    {
      dataIndex: '',
      title: '담당자',
      render: (value, data) => {
        return (
          <div className='manager'>{data?.responsiblity}</div>
        )
      }
    },
  ];

  return (
    <CurrentDepositWrapper>
      <DepositTitle IsMobile={IsMobile}>최근 입금 내역 ({currentDepositData?.length}건)</DepositTitle>
      <Table dataSource={currentDepositData} columns={ IsMobile ? mobileColumns : columns} />
    </CurrentDepositWrapper>
  )
}

export default React.memo(CurrentDeposit);